.screen {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 80px;
}

.radar {
  position: relative;
  width: 300px;
  height: 300px;
}
.radarSvg {
  position: absolute;
  inset: 0;
}
.track {
  stroke: var(--color-neutral-200);
}
.sweep {
  stroke: var(--color-accent);
  transform-origin: 50% 50%;
  animation:
    evx-spin 8s linear infinite,
    evx-pulse 2.4s ease-in-out infinite;
}
.orbit {
  stroke: var(--color-accent-300);
  transform-origin: 50% 50%;
  animation: evx-spinr 16s linear infinite;
}
.lockRing {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 180px;
  height: 180px;
  margin: -90px 0 0 -90px;
  border: 2px solid var(--color-success);
  border-radius: 50%;
  animation: evx-ringPulse 1.4s ease-out infinite;
}
.lockRing + .lockRing {
  border-width: 1px;
  animation-delay: 0.5s;
}
.unit {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.unitMark {
  font-family: var(--font-heading);
  font-weight: 800;
  font-size: 38px;
  color: var(--color-accent-400);
}
.linked .unitMark {
  color: var(--color-success);
}
.unitId {
  font-size: 11px;
  color: var(--color-neutral-600);
  font-weight: 700;
}

.panel {
  width: 400px;
}
.title {
  margin: 10px 0 6px;
  font-weight: 800;
  color: var(--color-text);
}
.linked .title {
  color: var(--color-success);
  animation: evx-reveal 0.5s ease both;
}
.subtitle {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-neutral-700);
  margin: 0 0 20px;
}
.banner {
  margin-top: 18px;
  padding: 12px 16px;
  background: var(--color-success-100);
  color: var(--color-success-700);
  border-radius: var(--radius-md);
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  animation: evx-okPulse 1.2s ease-out infinite;
}
